// extracted by mini-css-extract-plugin
export default {"fastCreateContainer":"FastCreate_fastCreateContainer__xnySl"};